export const LOADING_UNLINK_TEMPLATES = "LOADING_UNLINK_TEMPLATES";
export const SAVE_LOADING_UNLINK_TEMPLATES = "SAVE_LOADING_UNLINK_TEMPLATES";
export const GET_UNLINK_TEMPLATES = "GET_UNLINK_TEMPLATES";
export const FORM_FAIL = "FORM_FAIL";
export const UNLINK_TEMPLATES_FAIL = "DISCIPLINARY_ACTION_FAIL";

